



























































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import UserGoal from '../../../api/v2/models/user_goal';
import { UserExamDetail } from '../../../api/v2/models/user_exam';
import api from '../../../api/v2/api';

import ExamEvaluationComponent from './ExamEvaluation.vue'
import { ROUTER_NAME } from '../../router';

@Component({
  components: {
    ExamEvaluationComponent,
  }
})
export default class UserGoalUserExam extends Vue {

  @Prop({ required: true })
  userGoal: UserGoal

  @Prop({ required: true })
  userExamId: number

  userExam: UserExamDetail | null = null

  async created(){
    this.userExam = await api.userExam.show(this.userExamId)
  }
  
  gotoExamResult(){
    this.$router.push({
      name: ROUTER_NAME.EXAM_RESULT,
      params: {
        examId: `${this.userExam.examId}`
      },
      query: {
        user_exam_id: `${this.userExam.id}`
      }
    })
  }
}
